import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import { use } from '../Helpers.js'
import FormModal from '../Components/FormModal.js'

function Students () {
  const pageName = 'students'
  const pageTitle = 'İştirakçılar'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)


  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    actions: {
      get: async (params = {}) => {
        const students = await call.forLoggedUser.student.getStudents(params)
        if (students.success) {
          return students.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Adı və Soyadı',
        property: ['name', 'surname'],
        style: { width: '22%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'name'
        },
        mutate: values => {
          return values[0] + ' ' + values[1]
        }
      },
      {
        title: 'Filial',
        property: ['branchCode','branchName'],
        filter: {
          enabled: true,
          type: 'select',
          name: 'branchId',
          dataSource: async () => {
            const source = await call.forLoggedUser.branch.getBranches({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        mutate:(values)=><span title={values[1]}>{values[0]}</span>,
        style: { width: '10%' }
      },
      {
        title: 'Cari Qrup',
        property: 'groupName',
        style: { width: '16%' },
        mutate: value => {
          return [null, undefined, ''].includes(value) ? '-' : value
        },
        filter: {
          enabled: true,
          type: 'select',
          name: 'groupId',
          dataSource: async () => {
            const source = await call.forLoggedUser.group.getGroups({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        }
      },
      {
        title: 'Müraciətçi',
        property: 'requesterFullName',
        style: { width: '22%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'requesterFullName'
        }
      },
      {
        title: 'Cəmi ödəniş',
        property: 'totalPayments',
        type: 'number',
        style: { width: '10%' },
        filter: {
          enabled: false,
          type: 'number',
          name: 'totalPayments'
        },
        mutate: value => {
          return `${value} ₼`
        }
      },
      {
        title: 'Status',
        property: 'statusName',
        type:'status-label',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'student'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: value => {
          return value
        }
      },
      {
        title: 'Əməliyyat',
        property: 'id',
        type: 'actions-list',
        operations: value => [
          {
            type: 'link',
            name: 'edit',
            title: 'Düzəliş',
            link: `${value}`,
            iconType: 'path',
            icon: '/Images/Icons/edit.png',
            disablingConditions: []
          },
          {
            type:'command',
            name: 'groupTransfer',
            title:'Digər qrupa transfer et',
            iconType:'path',
            icon:'/Images/Icons/transfer.png',
            iconStyle:{filter:'invert(1)'},
            parameters: ['line:id','line:studentFullName','global:groupId'],
            disablingConditions: [
              {
                fieldName: 'statusId',
                checkCondition: value=>![0,1].includes(value)
              },
              {
                fieldName: 'groupId',
                checkCondition: [null,undefined,''].includes(value)
              }
            ]
          },
          {
            type:'command',
            name:'delete',
            title:'Qeydi sil',
            parameters:`{"id":${value},"entity":"student"}`,
            iconType:'path',
            icon:'/Images/Icons/delete.png',
            disablingConditions:[]
          }
        ],
        style: { width: '10%', minWidth: '50px' }
      }
    ],
    addNew: {
      enabled: true,
      url: `?requestType=command&commandName=addToGroup&token=xy103`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'student',
      label: 'İştirakçı',
      isStandAlone: true,
      isMain: true,
      id: '',
      actions: {
        get: id => call.forLoggedUser.student.getStudentById({ id: id }),
        add: call.forLoggedUser.student.addStudent,
        edit: call.forLoggedUser.student.updateStudent
      },
      formLists: {
        Genders: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'Gender'
          })
          return source.data.map(d => {
            return { value: d.value, text: d.text }
          })
        },
        Requests: async () => {
          const source = await call.forLoggedUser.request.getRequests({})
          return source.data.map(d => {
            return {
              value: d.id,
              text: `${use.convertDatetimeToShortDate(d.requestDate)} ${
                d.requesterFullName
              }`
            }
          })
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'student'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Filial',
          fieldName: 'branchName',
          type: 'readonly-text',
          col: { sm: 4 }
        },
        {
          label: 'Cari Qrup',
          fieldName: 'groupName',
          type: 'readonly-text',
          col: { sm: 8 }
        },
        {
          label: 'Adı',
          fieldName: 'name',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Soyadı',
          fieldName: 'surname',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Atasının adı',
          fieldName: 'middleName',
          col: { sm: 3 }
        },
        {
          label: 'Cinsiyyəti',
          type: 'select',
          fieldName: 'gender',
          col: { sm: 1 },
          data: 'Genders'
        },
        {
          label: 'Doğum tarixi',
          type: 'date',
          fieldName: 'birthDate',
          col: { sm: 2 },
          mutate: value => {
            return use.isNullorEmpty(value)
              ? new Date('2010-01-01').toLocaleDateString('AZ-az')
              : new Date(value).toLocaleDateString('AZ-az')
          }
        },
        {
          label: 'Qeydiyyat tarixi',
          type: 'date',
          fieldName: 'registrationDate',
          validationRules: ['required'],
          col: { sm: 3 },
          mutate: value => {
            return use.isNullorEmpty(value)
              ? new Date().toLocaleDateString('AZ-az')
              : new Date(value).toLocaleDateString('AZ-az')
          }
        },
        {
          label: 'Əlaqəli sorğu',
          type: 'select',
          fieldName: 'requestId',
          col: { sm: 3 },
          defaultSelectOptions: [{ value: '', text: 'Seçilməyib...' }],
          acceptNullValue: true,
          data: 'Requests'
        },
        {
          label: 'E-poçt',
          type: 'email',
          fieldName: 'email',
          col: { sm: 3 }
        },
        {
          label: 'Ünvan',
          fieldName: 'address',
          col: { sm: 3 }
        },
        {
          label: 'Telefon 1',
          fieldName: 'phone1',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Telefon 2',
          fieldName: 'phone2',
          col: { sm: 3 }
        },
        {
          label: 'Əlavə qeydlər',
          type: 'textarea',
          fieldName: 'notes',
          col: { sm: 3 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          defaultValue: 0,
          col: { sm: 3 },
          data: 'Statuses'
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    },
    {
      name: 'groups',
      id: '',
      label: 'Qruplar',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id => call.forLoggedUser.student.getGroupList({ studentId: id }),
        edit: call.forLoggedUser.student.editGroupList
      },
      formLists: {
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'studentGroup'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'studentId', label: '' },
        {
          label: 'Adı, soyadı, atasının adı',
          fieldName: 'studentFullName',
          type: 'readonly-text',
          col: { sm: 4 }
        },
        {
          label: 'Əlaqə',
          fieldName: 'phone',
          type: 'readonly-text',
          col: { sm: 3 }
        },
        {
          label: 'Cari Qrup',
          fieldName: 'groupName',
          type: 'readonly-text',
          col: { sm: 3 }
        },
        {
          label: 'Cari status',
          fieldName: 'statusName',
          type: 'readonly-text',
          col: { sm: 2 }
        },
        {
          label: 'Qruplar',
          type: 'input-group-row',
          fieldName: 'studentGroups',
          defaultValue: [],
          addRowPermission: false,
          multipleRows: true,
          removeRowPermission: false,
          defaultRowCountField: 'classesPerWeek',
          rowStyleRules: [
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            },
            {
              fieldName: 'statusId',
              getStyleRule: value => {
                switch (value) {
                  case 3:
                    return { backgroundColor: '#fffcd2ff' }
                  case -2:
                    return { backgroundColor: '#ffe9b0' }
                  default: {
                  }
                }
              }
            }
          ],
          col: { sm: 12 },
          rowFields: [
            { type: 'hidden', fieldName: 'id', col: { sm: 0 }, label: '' },
            { type: 'hidden', fieldName: 'groupId', col: { sm: 0 }, label: '' },
            {
              label: 'Qrup',
              type: 'text',
              fieldName: 'groupStatusName',
              disabled: true,
              columnWidth: '15%'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              columnWidth: '15%',
              data: 'Statuses'
            },
            {
              label: 'Qrupun adı',
              type: 'text',
              fieldName: 'groupName',
              disabled: true,
              validationRules: ['required'],
              columnWidth: '10%'
            },
            {
              label: 'Təlim',
              type: 'text',
              fieldName: 'courseName',
              disabled: true,
              validationRules: ['required'],
              columnWidth: '15%'
            },
            {
              label: 'Başlama tarixi',
              type: 'date',
              fieldName: 'startDate',
              validationRules: ['required'],
              columnWidth: '5%',
              mutate: value => {
                return value!=null?new Date(value).toLocaleDateString('az-AZ'):null
              }
            },
            {
              label: 'Bitirmə tarixi',
              type: 'date',
              fieldName: 'endDate',
              validationRules: ['required'],
              columnWidth: '5%',
              mutate: value => {
                return value!=null?new Date(value).toLocaleDateString('az-AZ'):null
              }
            },
            {
              label: 'Təlim qiyməti',
              type: 'number',
              fieldName: 'monthlyPrice',
              disabled: true,
              columnWidth: '10%'
            },
            {
              label: 'Aylıq ödəniş',
              type: 'number',
              fieldName: 'monthlyPayment',
              validationRules: ['required'],
              columnWidth: '10%'
            },
            {
              label: 'Nəticə',
              type: 'number',
              fieldName: 'grade',
              columnWidth: '5%'
            },
            {
              label: 'Qeydlər',
              type: 'text',
              fieldName: 'notes',
              columnWidth: '15%'
            },
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              operations: [
                {
                  type:'command',
                  name: 'groupTransfer',
                  title:'Qrupu dəyiş',
                  iconType:'path',
                  icon:'/Images/Icons/menu-icons/group.svg',
                  parameters: ['line:id','global:studentFullName','line:groupId'],
                  disablingConditions: [
                    {
                      fieldName: 'statusId',
                      checkCondition: value=>![0,1].includes(value)
                    }
                  ]
                },
                {
                  type: 'delete',
                  title: 'Sil',
                  iconType: 'path',
                  icon: '/Images/Icons/delete.png',
                  iconStyle: { filter: 'invert(1)' },
                  disablingConditions: [
                    {
                      fieldName: 'paidAmount',
                      checkCondition: value => value > 0
                    }
                  ]
                }
              ]
            }
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    },
    {
      name: 'payments',
      id: '',
      label: 'Ödənişlər',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id => call.forLoggedUser.student.getPaymentList({ studentId: id }),
        edit: call.forLoggedUser.student.editPaymentList
      },
      formLists: {
        PaymentTypes: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'PaymentType'
          })
          return source.data.map(d => {
            return { value: d.value, text: d.text }
          })
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'payment'
          })
          return source.data.map(d => {
            return { value: d.id, text: d.description }
          })
        },
        StudentGroups: async studentId => {
          const source = await call.forLoggedUser.student.getGroupList({
            studentId: studentId
          })
          return source.data.studentGroups?.map(g => {
            return { value: g.id, text: g.groupName }
          })
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'studentId', label: '' },
        {
          label: 'Adı, soyadı, atasının adı',
          fieldName: 'studentFullName',
          type: 'readonly-text',
          col: { sm: 4 }
        },
        {
          label: 'Əlaqə',
          fieldName: 'phone',
          type: 'readonly-text',
          col: { sm: 3 }
        },
        {
          label: 'Cari Qrup',
          fieldName: 'groupName',
          type: 'readonly-text',
          col: { sm: 3 }
        },
        {
          label: 'Cari status',
          fieldName: 'statusName',
          type: 'readonly-text',
          col: { sm: 2 }
        },
        {
          label: 'Ödənişlər',
          type: 'input-group-row',
          fieldName: 'payments',
          defaultValue: [],
          addRowPermission: true,
          multipleRows: true,
          removeRowPermission: true,
          col: { sm: 12 },
          rowStyleRules: [
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            }
          ],
          rowFields: [
            {
              label: '',
              fieldName: 'id',
              type: 'hidden'
            },
            {
              label: 'Tarix',
              type: 'date',
              fieldName: 'paidDate',
              defaultValue:new Date().toLocaleDateString('az-AZ'),
              validationRules: ['required'],
              columnWidth: '15%',
              mutate: value => {
                return value!=null?new Date(value).toLocaleDateString('az-AZ'):null
              }
            },
            {
              label: 'Qrup',
              type: 'select',
              fieldName: 'studentGroupId',
              validationRules: ['required'],
              columnWidth: '15%',
              data: 'StudentGroups'
            },
            {
              label: 'Tip',
              type: 'select',
              fieldName: 'paymentTypeId',
              columnWidth: '10%',
              data: 'PaymentTypes'
            },
            {
              label: 'Məbləğ',
              type: 'number',
              fieldName: 'amount',
              defaultValue:'0',
              validationRules: ['required'],
              columnWidth: '10%'
            },
            {
              label: 'Açıqlama',
              type: 'text',
              fieldName: 'description',
              columnWidth: '30%'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              columnWidth: '20%',
              defaultValue: 1,
              data: 'Statuses'
            },
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              operations:[
                {
                  type: 'delete',
                  title: 'Sil',
                  iconType: 'path',
                  icon: '/Images/Icons/delete.png',
                  iconStyle: { filter: 'invert(1)' },
                  disablingConditions: []
                }
              ]
            }
          ]
        },
        {
          label:'📊📈 Ödəniş statistikası',
          type:'info-table',
          fieldName:'paymentStats',
          defaultValue:[],
          showRowNumbers:false,
          col:{sm:12},
          rowFields:[
            {
              label:'Qrup',
              fieldName: 'groupName',
              columnWidth:'15%'

            },
            {
              label: 'Təlim',
              fieldName: 'courseName',
              columnWidth:'15%'
            },
            {
              label: 'Ümumi ödəniş',
              fieldName: 'totalPrice',
              columnWidth:'15%',
              mutate:(value)=>{
                return `${value} ₼`;
              }

            },
            {
              label: 'Ödənilmiş',
              fieldName: 'totalPaid',
              columnWidth:'15%',
              mutate:(value)=>{
                return `${value} ₼`;
              }

            },
            {
              label: 'Qaytarılmış',
              fieldName: 'totalRefund',
              columnWidth:'15%',
              mutate:(value)=>{
                return `${value} ₼`;
              }

            },
            {
              label: 'Qalıq',
              fieldName: 'remaining',
              columnWidth:'15%',
              mutate:(value)=>{
                return `${value} ₼`;
              }
            }
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Students
